import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocProgressSpinner } from 'commons/components/components-wrapper/poc-progress-spinner.component';
import { useTranslation } from 'core/i18n';
import { CustomAlarmActivationMode } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-activation-confirmation-modal/custom-alarm-active-confirmation-modal.model';
import { getButtonText } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-activation-confirmation-modal/custom-alarm-active-confirmation-modal.business';
import React from 'react';

export interface CustomAlarmActiveConfirmationModalFooterComponentProps {
    action: CustomAlarmActivationMode;
    isLoading: boolean;
    onConfirm: () => void;
}

export const CustomAlarmActiveConfirmationModalFooterComponent: React.FC<
    CustomAlarmActiveConfirmationModalFooterComponentProps
> = ({ action, isLoading, onConfirm }) => {
    const { t } = useTranslation();
    const buttonText = getButtonText(action);

    return (
        <PocButton
            id="custom-alarm-activation-confirmation-modal-button"
            key="custom-alarm-activation-confirmation-modal-button"
            data-testid="custom-alarm-activation-confirmation-modal-button"
            onClick={onConfirm}
            disabled={isLoading}
        >
            {isLoading ? <PocProgressSpinner size="xSmall" style={{ display: 'block' }} /> : t(buttonText)}
        </PocButton>
    );
};
